import { themeVars } from '@synoptic/ui-kit/theme/vars.ts';
import { space, borderRadius } from '@synoptic/ui-kit/tokens.js';
import { typography } from '@synoptic/ui-kit/typography.js';
import { style } from '@vanilla-extract/css';

export const container = style({
  display: 'flex',
  flexDirection: 'column',
  gap: space.s24,
});

export const subtitle = style({
  ...typography.bodyMd,
  color: themeVars.container.foreground.secondary,
});

export const balanceCard = style({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: space.s24,
  backgroundColor: themeVars.container.primary.background.idle,
  borderRadius: borderRadius.r12,
  border: `1px solid ${themeVars.container.border.default}`,
});

export const balanceInfo = style({
  display: 'flex',
  flexDirection: 'column',
  gap: space.s4,
});

export const balanceLabel = style({
  ...typography.labelMd,
  color: themeVars.container.foreground.secondary,
});

export const balanceValue = style({
  ...typography.displaySm,
  color: themeVars.container.foreground.primary,
});

export const balanceDollar = style({
  ...typography.bodyLg,
  color: themeVars.container.foreground.secondary,
});

export const sectionTitle = style({
  ...typography.titleLg,
  color: themeVars.container.foreground.primary,
  marginBottom: space.s12,
});

export const milestonesGrid = style({
  display: 'flex',
  flexDirection: 'column',
  gap: space.s12,
});

export const milestoneCardWrapper = style({
  padding: space.s16,
  backgroundColor: themeVars.container.primary.background.idle,
  borderRadius: borderRadius.r12,
  border: `1px solid ${themeVars.container.border.default}`,
  containerType: 'inline-size',
});

export const milestoneCard = style({
  display: 'flex',
  justifyContent: 'space-between',
  gap: space.s16,
  flexDirection: 'column',

  '@container': {
    ['(min-width: 500px)']: {
      flexDirection: 'row',
      alignItems: 'center',
    },
  },
});

export const milestoneContent = style({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  gap: space.s4,
});

export const milestoneTitle = style({
  ...typography.titleSm,
  color: themeVars.container.foreground.primary,
});

export const milestoneDescription = style({
  ...typography.bodySm,
  color: themeVars.container.foreground.secondary,
});

export const milestoneActions = style({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: space.s12,
  flexShrink: 0,
});

export const milestoneReward = style({
  ...typography.labelLg,
  flexShrink: 0,
  color: themeVars.container.foreground.brand,
});

export const videosGrid = style({
  display: 'flex',
  flexDirection: 'column',
  gap: space.s12,
});

export const videoCardContainer = style({
  containerType: 'inline-size',
  backgroundColor: themeVars.container.primary.background.idle,
  borderRadius: borderRadius.r12,
  border: `1px solid ${themeVars.container.border.default}`,
});

export const videoCard = style({
  display: 'flex',
  flexDirection: 'column',
  gap: space.s16,
  padding: space.s16,
  '@container': {
    ['(min-width: 500px)']: {
      flexDirection: 'row',
    },
  },
});

export const videoThumbnailContainer = style({
  position: 'relative',
  width: '100%',
  flex: '0 0 clamp(200px, 10cqw + 200px, 280px)',
  aspectRatio: '16 / 9',
  borderRadius: borderRadius.r8,
  overflow: 'hidden',
  cursor: 'pointer',
});

export const videoThumbnail = style({
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  display: 'block',
});

export const videoPlayOverlay = style({
  position: 'absolute',
  inset: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: 'rgba(0, 0, 0, 0.3)',
  transition: 'background 0.15s ease',
  selectors: {
    [`${videoThumbnailContainer}:hover &`]: {
      background: 'rgba(0, 0, 0, 0.5)',
    },
  },
});

export const videoPlayIcon = style({
  width: 48,
  height: 48,
  color: 'white',
  filter: 'drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3))',
});

export const videoContent = style({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  gap: space.s8,
});

export const videoInfo = style({
  display: 'flex',
  flexDirection: 'column',
  gap: space.s4,
});

export const videoTitle = style({
  ...typography.titleSm,
  color: themeVars.container.foreground.primary,
});

export const videoDescription = style({
  ...typography.bodySm,
  color: themeVars.container.foreground.secondary,
});

export const videoFooter = style({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: space.s12,
});

export const videoModalContainer = style({
  maxWidth: 920,
});

export const videoModalVideo = style({
  width: '100%',
  aspectRatio: '16 / 9',
  borderRadius: borderRadius.r8,
  outline: 'none',
});

export const loadingContainer = style({
  display: 'flex',
  justifyContent: 'center',
  padding: space.s48,
});
